'use client';

import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { GamePanel } from '../ui/GamePanel';
import { RpgButton } from '../ui/RpgButton';
import { BoardDirectory } from './BoardDirectory';
import { useLaunchTransition } from '../launch/LaunchTransitionProvider';

interface BoardListPanelProps {
  activeId: string;
  pendingId?: string | null;
  onSelect: (id: string) => void;
  className?: string;
}

/**
 * Desktop left-column board browser. Wraps `BoardDirectory` in the
 * gilded `GamePanel` chrome and stacks a prominent "Create a Board"
 * CTA on top. Mobile hoists `BoardDirectory` into a full-bleed view
 * from `LobbyClient` (triggered by the bottom-nav Lobby tab via
 * `?mode=lobby`), so this desktop panel is the only caller that
 * needs the surrounding chrome.
 */
export function BoardListPanel({
  activeId,
  pendingId,
  onSelect,
  className,
}: BoardListPanelProps) {
  const { begin: beginLaunchTransition } = useLaunchTransition();

  return (
    <GamePanel
      title="The Lobby"
      className={cn('w-[268px] flex flex-col', className)}
      bodyClassName="p-2 flex flex-col gap-2 flex-1 min-h-0"
    >
      <RpgButton
        tone="gold"
        size="md"
        iconLeft={<Plus className="h-3.5 w-3.5" />}
        className="w-full"
        onClick={(event) =>
          beginLaunchTransition({ clientX: event.clientX, clientY: event.clientY })
        }
      >
        Create a Board
      </RpgButton>

      <BoardDirectory
        activeId={activeId}
        pendingId={pendingId}
        onSelect={onSelect}
        fillHeight
        className="flex-1"
      />
    </GamePanel>
  );
}
